import { Validator } from 'fluentvalidation-ts';
import {
  BillOfMaterialsItemFormModel,
  BillOfMaterialsItemFormModelValidator,
  BillOfMaterialsItemsFieldNames,
  mapBillOfMaterialsItemToFormModel,
} from './billOfMaterialsItemFormModel';
import { BillOfMaterialsPartsById, BillOfMaterialsUnitResponse } from './dataForEditBillOfMaterialsForm';

export type BillOfMaterialsUnitFormModel = {
  billOfMaterialsUnitId: number;
  name: string;
  quantity: number;
} & Record<BillOfMaterialsItemsFieldNames, Array<BillOfMaterialsItemFormModel>> &
  Record<BillOfMaterialsUnitDescriptionFieldNames, string | null>;

export const mapToBillOfMaterialsUnitFormModel = (
  billOfMaterialsUnit: BillOfMaterialsUnitResponse,
): BillOfMaterialsUnitFormModel => ({
  billOfMaterialsUnitId: billOfMaterialsUnit.billOfMaterialsUnitId,
  name: billOfMaterialsUnit.name,
  underfloorHeatingDescription: billOfMaterialsUnit.underfloorHeatingDescription,
  heatPumpDescription: billOfMaterialsUnit.heatPumpDescription,
  solarDescription: billOfMaterialsUnit.solarDescription,
  quantity: billOfMaterialsUnit.quantity,
  underfloorHeatingItems: billOfMaterialsUnit.underfloorHeatingItems.map(mapBillOfMaterialsItemToFormModel),
  heatPumpItems: billOfMaterialsUnit.heatPumpItems.map(mapBillOfMaterialsItemToFormModel),
  solarItems: billOfMaterialsUnit.solarItems.map(mapBillOfMaterialsItemToFormModel),
});

export class BillOfMaterialsUnitFormModelValidator extends Validator<BillOfMaterialsUnitFormModel> {
  constructor(partsById: BillOfMaterialsPartsById) {
    super();

    this.ruleForEach('underfloorHeatingItems').setValidator(() => new BillOfMaterialsItemFormModelValidator(partsById));
    this.ruleForEach('heatPumpItems').setValidator(() => new BillOfMaterialsItemFormModelValidator(partsById));
    this.ruleForEach('solarItems').setValidator(() => new BillOfMaterialsItemFormModelValidator(partsById));
  }
}

export type BillOfMaterialsUnitDescriptionFieldNames =
  | 'underfloorHeatingDescription'
  | 'heatPumpDescription'
  | 'solarDescription';
